import React from "react";
import Divider from "./divider";

export default function () {
  return (
    <div id="contact" className="pb-24">
      <Divider />
      <div className="flex relative justify-center">
        <h2 className="text-6xl text-center font-semibold text-gray-800">
          Contact Us
        </h2>
        <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 transform w-80 h-3 bg-red-500"></div>
      </div>
      <div className="w-full font-semibold md:w-5/12 ml-auto mr-auto mt-16 text-center px-4">
        <p>
          <span className="text-xs">
            For any queries - course details - admission related
          </span>
          <span className="text-red-600 ml-2">info@reddwings.com</span>
        </p>
        <p>
          <span className="text-xs">For feedback - complain - suggestion</span>
          <span className="text-red-600 ml-2">care@reddwings.com</span>
        </p>
        <p>
          <span className="text-xs">For career at RAHi</span>
          <span className="text-red-600 ml-2">care@reddwings.com</span>
        </p>
      </div>
    </div>
  );
}
